import React from 'react';

interface Book {
    title: string;
    author: string;
    cover: string;
    note?: string;
    link?: string;
}

interface BookShelfProps {
    books: Book[];
    className?: string;
}

export const BookShelf: React.FC<BookShelfProps> = ({
    books,
    className = '',
}) => {
    return (
        <div className={`intellectual-books ${className}`}>
            {books.map((book, index) => (
                <div key={index} className="intellectual-book">
                    {book.link ? (
                        <a href={book.link} target="_blank" rel="noopener noreferrer">
                            <img
                                src={book.cover}
                                alt={book.title}
                                className="intellectual-book-cover"
                            />
                        </a>
                    ) : (
                        <img
                            src={book.cover}
                            alt={book.title}
                            className="intellectual-book-cover"
                        />
                    )}
                    <h4 className="intellectual-book-title">{book.title}</h4>
                    <p className="intellectual-book-author">by {book.author}</p>
                    {book.note && (
                        <p className="intellectual-book-note">"{book.note}"</p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default BookShelf;
